import { render, staticRenderFns } from "./StartPasswordRecoveryForm.vue?vue&type=template&id=fa0c38e2&scoped=true"
import script from "./StartPasswordRecoveryForm.js?vue&type=script&lang=js&external"
export * from "./StartPasswordRecoveryForm.js?vue&type=script&lang=js&external"
import style0 from "./StartPasswordRecoveryForm.vue?vue&type=style&index=0&id=fa0c38e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0c38e2",
  null
  
)

export default component.exports